jQuery(document).ready(function ($) {

    $('.container-fluid').on('click', '.js-pair-1', function () {
        var container = $(this).closest('.js-pair-container');
        var step1 = $(this).attr('data-pair');
        var step2 = container.find('.js-pair-2[data-pair="' + step1 + '"]');

        var bundle = step1.split('-');

        /* remove class form not needed elements and add to the selected ones*/
        container.find('.js-pair-2[data-pair^="' + bundle[0] +'-"]').removeClass('is-active');
        container.find('.js-pair-1[data-pair^="' + bundle[0] +'-"]').removeClass('is-active');
        $(step2).addClass('is-active');
        $(this).addClass('is-active');
    });


    $('.container-fluid').on('change', '.js-tab-select', function () {
        var container = $(this).closest('.js-pair-container');
        var step1 = this.value;
        var step2 = container.find('.js-pair-2[data-pair="' + step1 + '"]');

        var bundle = step1.split('-');

        /* remove class form not needed elements and add to the selected ones*/
        container.find('.js-pair-2[data-pair^="' + bundle[0] +'-"]').removeClass('is-active');
        $(step2).addClass('is-active');
    });

});
